import { render, staticRenderFns } from "./TransformPosition.vue?vue&type=template&id=15b21a02&"
import script from "./TransformPosition.vue?vue&type=script&lang=js&"
export * from "./TransformPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports